import { render, staticRenderFns } from "./article.vue?vue&type=template&id=a20c3a04&scoped=true"
import script from "./article.vue?vue&type=script&lang=js"
export * from "./article.vue?vue&type=script&lang=js"
import style0 from "./article.vue?vue&type=style&index=0&id=a20c3a04&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a20c3a04",
  null
  
)

export default component.exports